var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29289 12.0331C1.68342 11.6426 2.31658 11.6426 2.70711 12.0331L8.83711 18.1631C9.22763 18.5536 9.22763 19.1868 8.83711 19.5773C8.44658 19.9678 7.81342 19.9678 7.42289 19.5773L1.29289 13.4473C0.90237 13.0568 0.90237 12.4236 1.29289 12.0331Z",
    fill: "#554DDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.707 4.29289C23.0975 4.68342 23.0975 5.31658 22.707 5.70711L8.83699 19.5771C8.44647 19.9676 7.8133 19.9676 7.42278 19.5771C7.03225 19.1866 7.03225 18.5534 7.42278 18.1629L21.2928 4.29289C21.6833 3.90237 22.3165 3.90237 22.707 4.29289Z",
    fill: "#554DDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e9231ca79557dc6f10ba1488ccc7d667.svg";
export { ForwardRef as ReactComponent };